



























































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { NotificationEventBus } from '@/EventBus';
import { getModule } from 'vuex-module-decorators';
import Viewpoints, { ChoiceFactorScoreChange } from '@/store/modules/Viewpoints';
import Decisions from '@/store/modules/Decisions';
import Scoring from '@/store/modules/Scoring';
import Choices, { Choice } from '@/store/modules/Choices';
import FactorChoiceScoringViewpoint, { UpdateScoreRequest,} from '@/views/Ranker/FactorChoiceViewpointRankerBins.vue';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import ScoringKeyEditorDialog from '@/components/scoring-key/ScoringKeyEditorDialog.vue';
import FactorNavigationPublishedModel from '@/components/navigation/FactorNavigationPublishedModel.vue';
import Sticky from 'vue-sticky-directive';
import Modelling from '@/store/modules/Modelling';
import RankChoiceDialog from '@/views/Ranker/RankChoiceDialog.vue';
import WorkspaceOptionValues from '@/utils/WorkspaceOptionValues';
import RankerAdditionalActions from '@/views/Ranker/RankerAdditionalActions.vue';
import Apps from '@/store/modules/Apps';
import Users from '@/store/modules/Users';
import { Viewpoint } from "@/api/model/Viewpoint";
import ViewpointVisibilitySelectorMenu from '@/components/workspace-options/ViewpointVisibilitySelectorMenu.vue';
import AutocreateViewpointDialog from '@/components/common/AutocreateViewpointDialog.vue';
import CreateChoiceDialog from "@/views/ChoiceCards/CreateChoiceDialog.vue";

const appsModule = getModule(Apps);
const viewpointsModule = getModule(Viewpoints);
const modellingModule = getModule(Modelling);
const decisionsModule = getModule(Decisions);
const scoringModule = getModule(Scoring);
const choicesModule = getModule(Choices);
const usersModule = getModule(Users);
const workspaceOptionsModule = getModule(WorkspaceOptions);

@Component({
    components: {
        ScoringKeyEditorDialog,
        FactorChoiceScoringViewpoint,
        RankChoiceDialog,
        FactorNavigationPublishedModel,
        RankerAdditionalActions,
        AutocreateViewpointDialog,
        CreateChoiceDialog,
        ViewpointVisibilitySelectorMenu
    },
    directives: {
        Sticky,
    },
})
export default class ChoiceFactorRanker extends Vue {
    @Prop({ default: false, type: Boolean })
    embed!: boolean;

    @Prop({ default: false, type: Boolean })
    appEmbed!: boolean;

    private hoverId = '';
    private menu = false;
    private searchFactors: string | null = null;
    private readonly widthOptions: any[] = WorkspaceOptionValues.WIDTH_OPTIONS;
    private showCreateViewpointDialog = false;
    private createChoiceDialog = false;

    get currentUserId() {
        if(usersModule.currentUserProfile){
            return usersModule.currentUserProfile.userId;
        }else{
            return null;
        }
    }

    get appMenuName(){
        return appsModule.activeAppMenuName;
    }
    
    get commentBottomHeight() {
        return workspaceOptionsModule.commentBottomHeight;
    }

    get commentVertical() {
        return workspaceOptionsModule.commentVertical;
    }

    get pinnedRight() {
        return workspaceOptionsModule.pinnedRight;
    }

    get singularFactorLabel() {
        return decisionsModule.singularFactorLabel;
    }

    get cardContainerSize() {
        let commentHeight = 0;
        if (this.commentVertical && this.pinnedRight) {
            commentHeight = this.commentBottomHeight;
        } else if (!this.pinnedRight && this.appEmbed) {
            commentHeight = 40;
        } else {
            commentHeight = 0;
        }
        if (this.appEmbed) {
            return `min-height: calc(100vh - 148px - ${commentHeight}px); 
                    max-height: calc(100vh - 148px - ${commentHeight}px);`;
        } else if (this.embed) {
            return `max-height : calc(100vh - 112px); 
                    min-height:calc(100vh - 112px)`;
        } else {
            return `max-height : calc(100vh - 236px - ${commentHeight}px); 
                    min-height:calc(100vh - 236px - ${commentHeight}px)`;
        }
    }

    get mainContainerSize() {
        if (this.appEmbed) {
            return 'min-height: calc(100vh - 38px); max-height: calc(100vh - 38px);';
        } else if (this.embed) {
            return `max-height : calc(100vh); min-height:calc(100vh)`;
        } else {
            return `max-height : calc(100vh - 125px); min-height:calc(100vh - 125px)`;
        }
    }

    get descriptionVisibility() {
        return workspaceOptionsModule.descriptionVisibility;
    }

    get selectedViewpoints() {
        return viewpointsModule.selectedViewpoints;
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get singularViewpointLabel() {
        return decisionsModule.singularViewpointLabel;
    }

    get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel;
    }

    get pluralChoiceLabel() {
        return decisionsModule.pluralChoiceLabel;
    }

    get hasChoices() {
        return Object.keys(choicesModule.choices).length > 0;
    }

    get hasViewpoints() {
        return Object.keys(viewpointsModule.decisionViewpoints).length > 0;
    }

    get choiceData() {
        return choicesModule.choices;
    }

    get factors() {
        return modellingModule.publishedModelFactorResources;
    }

    get modifiedViewpoints() {
        if (this.selectedViewpoints) {
            return this.selectedViewpoints.filter((vp: any) => vp.changed);
        }
    }

    get selectedDraftViewpointChoiceScores() {
        return viewpointsModule.viewpointChoiceFactorResource;
    }

    get isLoaded() {
        return !!(this.factors && this.choiceData && this.selectedDraftViewpointChoiceScores);
    }

    get selectedItem() {
        let factorResourceId = workspaceOptionsModule.selectedPathItemId;
        return this.factors[factorResourceId];
    }

    get selectedFactorName() {
        if (this.selectedItem && this.factors.hasOwnProperty(this.selectedItem.id)) {
            return this.factors[this.selectedItem.id].name;
        }

        return '- select one -';
    }

    get name() {
        if (this.selectedItem) {
            // if (this.selectedItem.groups && this.selectedItem.groups.length > 1) {
            //     return this.selectedItem.groups.map((gId: string) => this.factorGroups[gId].name).join("/")
            // }
            return this.selectedItem.name;
        }
    }

    get columnWidth(): number {
        return workspaceOptionsModule.rankChoiceCol;
    }

    set columnWidth(columnWidth: number) {
        workspaceOptionsModule.setRankChoiceCol(columnWidth);
    }

    private submitting = false;

    // description
    private getDescriptionVisibility() {
        return this.descriptionVisibility;
    }

    private updateScore(updateScoreRequest: UpdateScoreRequest) {
        let payload: ChoiceFactorScoreChange = {
            viewpointId: updateScoreRequest.viewpointId,
            choiceId: updateScoreRequest.choiceId,
            factorId: updateScoreRequest.id,
            score: updateScoreRequest.newScore,
        };
        NotificationEventBus.emitProcessingMessage();
        viewpointsModule
            .putViewpointChoiceFactorScore(payload)
            .then((result) => NotificationEventBus.emitSuccessMessage())
            .catch((err) => NotificationEventBus.emitFailedMessage(err));
    }

    private async createAutocreateViewpoint(payload: any) {
        NotificationEventBus.emitProcessingMessage();
        this.showCreateViewpointDialog = false;
        let newViewpoint = {
            viewpointId: '',
        };
        try {
            if (!this.selectedDecision) return;
            let newVp = {
                decisionId: this.selectedDecision.decisionId,
                name: payload.name,
                description: payload.description,
                addToList: true
            }
            newViewpoint =  await decisionsModule.createDecisionViewpoint(newVp);
            if(newViewpoint?.viewpointId != '' && workspaceOptionsModule.activeViewpointLists.length > 0) {
                decisionsModule.addViewpointToActiveLists(newViewpoint.viewpointId)
            }
            
            NotificationEventBus.emitSuccessMessage()
            this.showCreateViewpointDialog = false;
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err)
        }
    
    }

    private async editAutocreateViewpoint(payload: Viewpoint) {
        await viewpointsModule.selectActiveViewpoint(payload.viewpointId);
        this.showCreateViewpointDialog = false;
    }

    private async createChoice(name: string) {
        let choice: Choice = {
            name: name,
            image: null,
            lastUpdatedTimestamp: null,
            creationTimestamp: null,
            visibility: 'ALL',
            ownerUserId: this.currentUserId
        }
        let newChoice = await choicesModule.createChoice(choice);
        this.createChoiceDialog = false;
        if(workspaceOptionsModule.activeChoiceLists.length > 0) {
            await decisionsModule.addChoiceToActiveLists(newChoice.id)
            await decisionsModule.getDecisionLists();
        }
        await choicesModule.fetchChoices();
        choicesModule.selectChoice(newChoice.id);
    }

    private editChoice(choice: Choice) {
        choicesModule.selectChoice(choice.id)
        this.createChoiceDialog = false;
    }
}
